<section *ngIf="!isOpened">
  <div class="row">
    <div class="col-12 col-sm-12">
      <form class="needs-validation container-style" [formGroup]="formUser" autocomplete="off">
        <div class="ps-2 pe-2">
          <div class="row pt-1">
            <div class="col">
              <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
                [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
            </div>
            <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            </div>
            <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
              <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
                (onClick)="deleteUser()"></app-custom-button>
              <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'"
                [width]="'5.5rem'" [severity]="'success'" [variant]="undefined"
                (onClick)="createNewUser()"></app-custom-button>
            </div>
            <hr class="my-1">
          </div>
          <div class="row mt-1">
            <div class="col-lg-10 col-md-9 col-sm-12 col-12 pe-md-2">
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-4 col-6">
                  <app-custom-input-text formControlName="userName" [labelText]="'Usuario'" [recovery]="true"
                    [required]="true" (onChangeTextOnBlur)="changeUser()" [maxLength]="250">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 col-6">
                  <app-custom-input-text formControlName="firstName" [labelText]="'Nombres'" [required]="true"
                    [maxLength]="150">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 col-6">
                  <app-custom-input-text formControlName="lastName" [labelText]="'Apellidos'" [required]="true"
                    [maxLength]="150">
                  </app-custom-input-text>
                </div>
                <div class="col-lg-2 col-md-3 col-sm-3 col-4">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateText"></app-custom-tag>
                </div>
                <div class="col-lg-1 col-md-1 col-sm-1 col-2 d-flex align-items-end gap-2">
                  <app-custom-button [icon]="iconState" [title]="titleState" [severity]="'primary'"
                    (onClick)="changeState()"></app-custom-button>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 col-6">
                  <app-custom-autocomplete formControlName="profileUserId" [labelText]="'Perfil'" [required]="true"
                    [list]="listProfiles">
                  </app-custom-autocomplete>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-4 col-6">
                  <app-custom-select formControlName="principalBranchId" [labelText]="'Sucursal Ppal.'"
                    [list]="listBranches" [required]="true"></app-custom-select>
                </div>
                <div class="col-lg-5 col-md-4 col-sm-4 col-12">
                  <app-custom-input-text formControlName="email" [labelText]="'Correo'" [maxLength]="256">
                  </app-custom-input-text>
                </div>
                <div *ngIf="isUserCreate" class="col-lg-3 col-md-4 col-sm-4 col-6">
                  <app-custom-input-password formControlName="passwordHash"
                    [labelText]="'Contraseña'"></app-custom-input-password>
                </div>
                <div *ngIf="isUserCreate" class="col-lg-3 col-md-4 col-sm-4 col-6">
                  <app-custom-input-password formControlName="confirmPasswordHash"
                    [labelText]="'Confirmar Contraseña'"></app-custom-input-password>
                </div>
                <div class="col-lg-2 col-md-4 col-sm-4 col-6">
                  <app-custom-input-decimal formControlName="rateDiscountMax" [labelText]="'% Máx.Dcto.'"
                    [required]="true" [disabled]="true"></app-custom-input-decimal>
                </div>
                @if (swAppMovil) {
                <div class="field-checkbox">
                  <app-custom-checkbox formControlName="accessApp" [labelText]="'Acceso App'"></app-custom-checkbox>
                </div>

                <div class="field-checkbox">
                  <app-custom-checkbox formControlName="accesWeb" [labelText]="'Acceso Web'"></app-custom-checkbox>
                </div>

                <div class="field-checkbox">
                  <app-custom-checkbox formControlName="viewAllOrders"
                    [labelText]="'Ver todos los pedidos'"></app-custom-checkbox>
                </div>
                }
                <div class="field-checkbox">
                  <app-custom-checkbox formControlName="accessAllCostCenters"
                    [labelText]="'Acceso a todos los c.costos'"></app-custom-checkbox>
                </div>
                <div class="container-btns d-flex align-items-center">
                  <div class="d-flex gap-2">
                    <app-custom-button class="col-lg-2 col-md-4 col-sm-4 col-6" [title]="'Acceso C.Costos'"
                      [label]="'Acceso C.Costos'" [width]="'8.5rem'" [severity]="'primary'"
                      [disabled]="disabledAccessCostCenter" (onClick)="openCostCenterUserModal()">
                    </app-custom-button>
                  </div>
                </div>
                <app-custom-modal #costCenterUserModal [label]="'Acceso C.Costos'" [header]="'Acceso C.Costos'"
                  [inputs$]="inputsForCostCenterUserModals$" [children]="componentCostCenterUserModal" hidden>
                </app-custom-modal>
              </div>
            </div>
            <div class="col-lg-2 col-md-3 col-sm-12 col-12">
              <div class="row">
                <div
                  class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex align-items-end flex-row flex-md-column gap-2 mt-3 ">
                  <app-custom-button [title]="'Cambiar Contraseña'" [label]="'Cambiar Contraseña'"
                    [severity]="'primary'" [icon]="'pi pi-key'" [disabled]="userId==0"
                    (onClick)="openUpdatePasswordModal()" [width]="'10rem'"></app-custom-button>
                  <app-custom-modal #updatePassword [label]="'Cambiar Contraseña'" [header]="'Cambiar Contraseña'"
                    [children]="componentUpdatePassword" [inputs$]="inputsForUpdatePassword$" [width]="'30vw'"
                    hidden></app-custom-modal>
                  <app-custom-button [title]="'Permisos'" [label]="'Permisos'" [severity]="'primary'"
                    [icon]="'pi pi-file-edit'" [disabled]="userId==0" (onClick)="openOptionWindowUser()"
                    [width]="'10rem'"></app-custom-button>
                  <app-custom-modal #optionWindowUser [label]="'Permisos de Usuario'" [header]="'Permisos de Usuario'"
                    [children]="componentOptionWindowUser" [inputs$]="inputsForOptionWindowUser$" [width]="'70vw'"
                    hidden></app-custom-modal>
                </div>
              </div>
            </div>
            <hr class="my-2">
            <div class="col-lg-12 col-md-12 col-sm-12 col-12 pt-1">
              <div class="row">
                <div class="col-lg-4 col-md-5 col-sm-4 col-6 mb-1 header-branch">
                  <h6 class="p-0">Acceso a Sucursales</h6>
                  <form class="form-branch" formGroupName="branch">
                    <app-custom-select formControlName="branchId" [labelText]="'Sucursales'" [list]="listBranches"
                      (onChangeSelect)="addBranch()"></app-custom-select>
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 pt-1">
                  <ol *ngIf="branchesUser.length!= 0" class="list-group">
                    <li class="header-list list-group-item d-flex justify-content-between align-items-start px-2">
                      <h6 class="mb-0">Sucursales asignadas</h6>
                    </li>
                    <li class="list-group-item d-flex justify-content-between align-items-start px-2"
                      *ngFor="let branch of branchesUser">
                      <div class="ms-8 me-auto ">
                        <span class="d-flex align-items-center branchs">{{branch.label}}</span>
                      </div>
                      <app-custom-button [title]="'Eliminar'" [severity]="'danger'" [icon]="'pi pi-times'"
                        [disabled]="!permissionUpdatable" (onClick)="deleteBranch(branch.value)"></app-custom-button>
                    </li>
                  </ol>
                </div>
                <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end align-items-end mt-3">
                  <app-custom-button [disabled]="disabledForm" [label]="'Guardar'" [severity]="'primary'"
                    [variant]="undefined" (onClick)="send()"></app-custom-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>